import { render, staticRenderFns } from "./EnterYourDetails.vue?vue&type=template&id=2cbb0dbc"
import script from "./EnterYourDetails.vue?vue&type=script&lang=js"
export * from "./EnterYourDetails.vue?vue&type=script&lang=js"
import style0 from "./EnterYourDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports